import { useAuth } from '@calefy-inc/authentication';

export const useAllowByEmailDomain = (emailDomain: string | Array<string>) => {
  const { userDomain } = useAuth();

  return (typeof emailDomain === 'string' ? [emailDomain] : emailDomain).some(
    (allowedDomain) => allowedDomain === userDomain,
  );
};
